import { AppState } from '../../../reducers/index';
import { createSelector } from '@ngrx/store';
import * as fromServiceBillingDetailReducer from './service-billing-detail.reducer';

export const currentState = (state: AppState) => (state[fromServiceBillingDetailReducer.serviceBillingDetailsFeatureKey]);

export const selectAllServiceBillingDetails = createSelector(currentState, fromServiceBillingDetailReducer.selectAll);

export const selectTotalServiceBillingDetails = createSelector(currentState, fromServiceBillingDetailReducer.selectTotal);

export const selectModifiedServiceBillingDetails = createSelector(selectAllServiceBillingDetails, (serviceBillingDetails) => {
  return serviceBillingDetails.map((serviceBillingDetail) => {
    return {
      ...serviceBillingDetail
    };
  });
});
